import styled from 'styled-components';


export const Container = styled.div`
    background: var(--surface-canvas);
    width: 262px;
    height: 330px;
    backdrop-filter: blur(4px);
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    margin-left: 31px;
    .lineRight {
        bottom: 33px;
        left: 90px;
    }

    .lineLeft {
        bottom: 36px;
        right: 90px;
    }
    .cardWidth {
        width: 102px;
    }
    div {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        h3 {
            font-family: var(--font-body);
            font-style: normal;
            font-weight: 700;
            font-size: 36px;
            line-height: 56px;
            text-align: center;
            color: var(--text-secondary);
            padding-top: 10px;
        }

        h6 {
            font-family: var(--font-body);
            font-style: normal;
            font-weight: 500;
            font-size: 20px;
            line-height: 24px;
            text-align: center;
            letter-spacing: 0.15px;
            color: var(--text-secondary);
        }

        span {
            font-family: var(--font-body);
            font-style: normal;
            font-weight: 400;
            font-size: 16px;
            line-height: 24px;
            text-align: center;
            color: var(--text-primary);
        }

        .cardTitle {
            margin-top: 21px;
            margin-bottom: 22px;
        }

        .containerNumber {
            margin-top: 27px;
            width: 56px;
            height: 56px;
            border: 2px dashed var(--action-accent-surface);
            border-radius: 30px;
        }
        .cardBodyMin {
            max-width: 180px;
        }
    }
`;